import { Checkbox, Icon, Tooltip } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useTracking from '../../../../../../../common/src/hooks/tracking/useTracking';
import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';
import { useAskLaterQuestionsMutation } from './api/postAskLaterQuestion';
import useIsCheckedAskedLater from './hooks/useIsCheckAskedLater';

interface Props {
  question: FlowsQuestion;
  show?: boolean;
}

const AskLaterQuestionsCheckbox: React.FC<Props> = ({ question, show }) => {
  const { t } = useTranslation();
  const isChecked = useIsCheckedAskedLater(question);
  const { trackEvent } = useTracking();
  const { mutate } = useAskLaterQuestionsMutation();

  const isPreviewModeOn = useFlowsSelector(
    (state) => state.flows.isPreviewModeOn,
  );

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    if (e.currentTarget.checked) trackEvent('Added a question to ask later');
    // This does an optimistic update
    mutate([
      {
        question_id: question.id,
        active: e.currentTarget.checked,
      },
    ]);
  };

  if (isChecked || show)
    return (
      <Tooltip
        label={t('FLOWS_COMPANY-SCAN_PREVIEW_DISABLED-TOOLTIP')}
        isDisabled={!isPreviewModeOn}
        shouldWrapChildren
      >
        <Checkbox
          variant="rounded"
          size="lg"
          icon={<Icon name="GeneralStatusSuccessCheckmark" boxSize="4" />}
          isChecked={isChecked}
          onChange={handleChange}
          isDisabled={isPreviewModeOn}
          _disabled={{ opacity: 0.4 }}
        />
      </Tooltip>
    );

  return null;
};

export default AskLaterQuestionsCheckbox;
